module.exports = {
          srcSet: __webpack_public_path__ + "public/b2a06d302bfb39f518a70d81c53870fd-180.png"+" 180w",
          images:[ {path: __webpack_public_path__ + "public/b2a06d302bfb39f518a70d81c53870fd-180.png",width: 180,height: 220}],
          src: __webpack_public_path__ + "public/b2a06d302bfb39f518a70d81c53870fd-180.png",
          toString:function(){return __webpack_public_path__ + "public/b2a06d302bfb39f518a70d81c53870fd-180.png"},
          
          width: 180,
          height: 220
        }